import { Avatar, Input } from 'antd';
import { Col } from 'components/Box/Col';
import { Row } from 'components/Box/Row';
import Button from 'components/Button';
import { IcComment, IcHistory } from 'components/Icon/icons';
import Text from 'components/Text';
import { IComment } from 'pages/request-support/interfaces/apis';
import styled from 'styled-components';

interface CommentAndActivityProps {
  comments?: IComment[];
  handleAddComment?: (note: string) => Promise<void>;
  note?: string;
  setNote?: (note: string) => void;
}
const CommentAndActivity = ({ comments, handleAddComment, note, setNote }: CommentAndActivityProps) => {

  return (
    <>
      <Row alignItems='center' style={{ gap: 16 }}>
        <IcComment />
        <Text variant='CONTENT_2'>Comments and activity</Text>
      </Row>
      <Col width='100%'>
        <Input.TextArea
          rows={4}
          placeholder='Add a comment...'
          value={note}
          onChange={(e) => setNote?.(e.target.value)}
        />
        {note && (
          <Button
            style={{ alignSelf: 'flex-start', padding: '0px 12px', fontSize: '14px!important', height: '32px' }}
            onClick={() => handleAddComment?.(note)}
            variant='GREEN'
            size='small'
            htmlType='button'
          >
            Add
          </Button>
        )}
      </Col>
      <Row justifyContent='flex-start'>
        <IcHistory />
        <Text variant='CAPTION_3' color='text_2'>
          Created time:
        </Text>
        <Text variant='BODY_2' color='text_2'>
          01/01/2025 12:00 PM
        </Text>
      </Row>
      <Content>
        {comments?.map((comment) => (
          <Row key={comment.id} style={{ gap: 12, alignItems: 'flex-start' }}>
            <Avatar src={comment.avatar} style={{ backgroundColor: '#FF7D00' }} size={32}>
              {comment.name.charAt(0).toUpperCase()}
            </Avatar>
            <Col flex={1}>
              <Row>
                <Text variant='CONTENT_2' color='text_2'>
                  {comment.name}
                </Text>
                <Text variant='BODY_1' color='text_2'>
                  {comment.date}
                </Text>
              </Row>
              <Comment>
                <Text variant='BODY_1'>{comment.comment}</Text>
              </Comment>
            </Col>
          </Row>
        ))}
      </Content>
    </>
  );
};

export default CommentAndActivity;

const Comment = styled.div`
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #dadada;
  background: #fff;
`;

const Content = styled.div`
  width: 100%;
  max-height: calc(700px - 200px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 0px;
  }
`;
